import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapLocationIcon = _resolveComponent("MapLocationIcon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    border: "",
    size: "small",
    data: _ctx.report.rows
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, null, {
        header: _withCtx(() => [
          _createElementVNode("span", null, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_MapLocationIcon)
              ]),
              _: 1 /* STABLE */
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.getCountryName(_ctx.report.countryName)), 1 /* TEXT */)
          ])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MGA_REPORT_TABLE.headers, (header) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: header.value,
              prop: header.value,
              label: header.text,
              width: header.width,
              formatter: header.formatter
            }, null, 8 /* PROPS */, ["prop", "label", "width", "formatter"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data"]))
}